export enum EBoardwalkPage {
    DeclinePage = "DeclinePage",
    RedirectUserDuplicate = "RedirectUserDuplicate",
    offers = "MarketingOffers",
    thankyou = "MarketingThankYou",
    ThankYouPage = "ThankYouPage",
    insurance = "MarketingInsurance",
    auto = "MarketingAuto",
    credit = "MarketingCredit",
    financial = "MarketingFinancial",
    ecommerce = "MarketingEcommerce",
    debt = "MarketingDebt",
    loans = "MarketingLoans",
    home = "MarketingHome",
    path = "MarketingPath"
}